const STEPS = [
  {
    icon: 'fa-hand-pointer',
    sanskrit: 'Chayan',
    title: 'Choose Your Pooja',
    text: 'Pick the ritual, temple and package that matches your sankalp — individual, couple or full family.',
  },
  {
    icon: 'fa-file-signature',
    sanskrit: 'Sankalp',
    title: 'Add Name & Gotra',
    text: 'Enter the devotee names, gotra and your WhatsApp number at checkout. Pandit Ji recites them before the ritual.',
  },
  {
    icon: 'fa-fire',
    sanskrit: 'Anushthan',
    title: 'Priests Perform the Ritual',
    text: 'Verified temple priests complete the pooja on the scheduled date with full Vedic vidhi.',
  },
  {
    icon: 'fa-video',
    sanskrit: 'Prasad',
    title: 'Video & Prasad Reach You',
    text: 'The sankalp and pooja video arrives on WhatsApp within 24 hours; prasad is couriered on family packages.',
  },
]

/** The 4-step booking journey — how a pooja ordered online actually reaches
 * the devotee. Dark section, mirrors RitualProcessSection's visual language. */
export default function HowItWorksSection() {
  return (
    <section className="py-20 md:py-24 md:px-12 bg-[#140608] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(55%_50%_at_50%_0%,rgba(232,119,15,0.10),transparent_70%)]" />
      <div className="container relative z-10 mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl mx-auto text-center space-y-3 mb-14">
          <div className="flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Seva Made Simple</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-[#FBF3E4]">
            How Your Pooja <span className="text-gradient-gold font-bold block">Reaches The Temple</span>
          </h2>
          <p className="text-xs md:text-sm leading-relaxed text-white/50 normal-case">
            From your screen to the sanctum in four steps — every booking is performed physically
            at the temple, never symbolically.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-4">
          {STEPS.map((step, i) => (
            <div
              key={step.title}
              className="relative rounded-3xl border border-white/10 bg-white/5 p-8 transition-all duration-300 hover:border-goldPrimary/40 hover:bg-white/10"
            >
              <span className="absolute top-6 right-6 font-heading text-4xl text-white/10 font-bold">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/5 border border-white/10 text-secondary">
                <i className={`fa-solid ${step.icon} text-xl`}></i>
              </div>
              <p className="mt-6 text-[10px] font-mono uppercase tracking-[0.3em] text-white/40">॥ {step.sanskrit} ॥</p>
              <h3 className="mt-1 font-heading text-lg uppercase font-bold text-[#FBF3E4]">{step.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/60 normal-case">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
